import { EJStatus, Permission } from '@cims-online/shared'
import { CustomRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import { EngineeringJudgement } from '../../../EJLogContext/types'
import { useEJLogContext } from '../../../EJLogContext'

export function useCustom(): CustomRowActionOptions<EngineeringJudgement>[] {
  const {
    revertModal: { toggle },
  } = useEJLogContext()
  return [
    {
      text: 'Revert',
      permission: Permission.RevertEngineeringJudgement,
      hidden: ({ statusId, deleted }) =>
        deleted || statusId !== EJStatus.Closed.id,
      onClick: (record) => toggle(record),
    },
  ]
}
